/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum PaidPeriodTypeDto {
    DAY = 'Day',
    WEEK = 'Week',
    MONTH = 'Month',
    ALL_TIME = 'AllTime',
}
